// extracted by mini-css-extract-plugin
module.exports = {"Head":"HeadingWithLink__Head_GUJxH","Title":"HeadingWithLink__Title_3CsRV","Link":"HeadingWithLink__Link_1Mf2w"};